import React, { FC, useEffect, useState } from 'react';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
import { getMemberInfo } from 'src/utils/common';
import { useQueryClient } from '@tanstack/react-query';
import { familyDataStore } from 'src/store/familyInfo';
import { othincomeInfoDataFn } from 'src/fetch/stepC/othincome';
import { OthincomeDataStore } from 'src/store/othincome';
import TabButton from 'src/components/atoms/buttons/TabButton';
import SmallBusinessGrid from 'src/components/molecules/table/SmallBusinessGrid';
import SecuritiesGrid from 'src/components/molecules/table/SecuritiesGrid';
import InvestmentGrid from 'src/components/molecules/table/InvestmentGrid';

import './style.scss';

interface Props {
  type: string;
}
const CreditCardSet: FC<Props> = ({ type }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const familyInfoDataState = familyDataStore((state: any) => state.bind);
  const loadingSate = loadingModalViewStore((state: any) => state.set);
  // 그밖의소득공제
  const othincomeDataState = OthincomeDataStore((state: any) => state.bind);
  const othincomeParam = OthincomeDataStore((state: any) => state.param);

  const param = userInfoData;
  // 기타
  useEffect(() => {
    othincomeInfoDataFn(
      errorModalState,
      param,
      othincomeDataState,
      queryClient,
      familyInfoDataState
    );
  }, [othincomeParam]);

  const setContent = () => {
    const selectMenu = menuState.menu.find(item => item.active);
    const selectId = selectMenu?.id || 'credit';
    let grid = <SmallBusinessGrid type={type} />;
    if (selectId === 'securities') grid = <SecuritiesGrid type={type} />;
    if (selectId === 'investment') grid = <InvestmentGrid type={type} />;
    return grid;
  };

  const tabMenu = [
    { active: true, title: '소기업/소상공인 공제부금', id: 'smallbusiness' },
    { active: false, title: '장기집합 투자증권 저축', id: 'securities' },
    { active: false, title: '투자조합출자(벤처기업투자신탁)', id: 'investment' },
  ];
  const [menuState, setMenuState] = useState({ menu: tabMenu });

  const tabClickEvent = (selectItem: any) => {
    menuState.menu.forEach(item => {
      item.active = false;
      if (item.id === selectItem.id) item.active = true;
    });
    setMenuState({ menu: menuState.menu });
  };

  return (
    <div className="_creditcard_view_set_insert_div">
      <section className="_content_div">
        <div className="_detail_info">
          <SmallBusinessGrid type={type} />
        </div>
      </section>
    </div>
  );
};

export default CreditCardSet;
